"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _range = _interopRequireDefault(require("../../utils/underscore/range"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _Functions = require("../../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _TabIndex = require("../../utils/TabIndex");

var _UIIconToggle = _interopRequireDefault(require("../UIIconToggle"));

var _Controllable = _interopRequireDefault(require("../../decorators/Controllable"));

var _deprecated = _interopRequireDefault(require("../../utils/propTypes/deprecated"));

var UIAbstractRatingInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIAbstractRatingInput, _Component);

  function UIAbstractRatingInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIAbstractRatingInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIAbstractRatingInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      focusValue: null
    };

    _this.handleChange = function (value) {
      if (_this.props.disabled || _this.props.readOnly) {
        return;
      }

      (0, _Functions.callIfPossible)(_this.props.onChange, (0, _SyntheticEvent.default)(value));
    };

    _this.handleKeyDown = function (evt) {
      var _this$props = _this.props,
          iconCount = _this$props.iconCount,
          value = _this$props.value;
      var nextValue = value || 0;

      if (evt.key === 'ArrowLeft') {
        nextValue = Math.floor(nextValue) <= 0 ? 0 : Math.ceil(nextValue) - 1;
      } else if (evt.key === 'ArrowRight') {
        nextValue = Math.ceil(nextValue) >= iconCount ? iconCount : Math.floor(nextValue) + 1;
      }

      _this.handleChange(nextValue);
    };

    _this.handleHover = function (value) {
      if (_this.props.disabled) {
        return;
      }

      _this.setState({
        focusValue: value
      });
    };

    return _this;
  }

  (0, _createClass2.default)(UIAbstractRatingInput, [{
    key: "getPercentageFilled",
    value: function getPercentageFilled(index, value) {
      if (value == null) {
        return 0;
      }

      if (this.state.focusValue) {
        if (index <= this.state.focusValue) {
          return 100;
        }

        return 0;
      }

      if (index <= Math.floor(value)) {
        return 100;
      }

      if (index > Math.ceil(value)) {
        return 0;
      }

      return Math.round(value % 1 * 100);
    }
  }, {
    key: "getIsHighlighted",
    value: function getIsHighlighted(index, value) {
      if (this.state.focusValue !== null) {
        return index <= this.state.focusValue;
      }

      return index <= value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          RatingComponent = _this$props2.Component,
          IconComponent = _this$props2.IconComponent,
          disabled = _this$props2.disabled,
          iconCount = _this$props2.iconCount,
          tabIndex = _this$props2.tabIndex,
          value = _this$props2.value,
          readOnly = _this$props2.readOnly,
          showPercentage = _this$props2.showPercentage,
          id = _this$props2.id,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "Component", "IconComponent", "disabled", "iconCount", "tabIndex", "value", "readOnly", "showPercentage", "id"]),
          focusValue = this.state.focusValue;
      return _react.default.createElement("div", {
        id: id,
        "aria-disabled": disabled,
        "aria-valuemax": iconCount,
        "aria-valuemin": "0",
        "aria-valuenow": value || 0,
        "aria-valuetext": _I18n.default.text('salesUI.UIIconRating.ariaValueText', {
          value: value || 0,
          maxValue: iconCount
        }),
        className: className,
        role: "slider",
        tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
        onKeyDown: this.handleKeyDown
      }, (0, _range.default)(1, iconCount + 1).map(function (i) {
        if (RatingComponent) {
          return _react.default.createElement(RatingComponent, (0, _extends2.default)({}, rest, {
            key: i,
            index: i,
            onChange: (0, _partial.default)(_this2.handleChange, i),
            onMouseEnter: (0, _partial.default)(_this2.handleHover, i),
            onMouseLeave: (0, _partial.default)(_this2.handleHover, null),
            "aria-label": "",
            checked: _this2.getIsHighlighted(i, value),
            disabled: disabled,
            readOnly: readOnly,
            percentFilled: showPercentage ? _this2.getPercentageFilled(i, value) : null,
            tabIndex: -1
          }));
        }

        return _react.default.createElement(_UIIconToggle.default, (0, _extends2.default)({}, rest, {
          key: i,
          index: i,
          onChange: (0, _partial.default)(_this2.handleChange, i),
          onMouseEnter: (0, _partial.default)(_this2.handleHover, i),
          onMouseLeave: (0, _partial.default)(_this2.handleHover, null),
          "aria-label": "",
          checked: _this2.getIsHighlighted(i, value),
          readOnly: readOnly,
          percentFilled: showPercentage ? _this2.getPercentageFilled(i, value) : null,
          tabIndex: -1,
          IconComponent: IconComponent,
          active: value === i,
          disabled: disabled,
          focus: i === focusValue,
          hover: i <= focusValue
        }));
      }));
    }
  }]);
  return UIAbstractRatingInput;
}(_react.Component);

UIAbstractRatingInput.propTypes = {
  Component: (0, _deprecated.default)(_propTypes.default.elementType, {
    message: "UIAbstractRatingInput: the `Component` prop has been deprecated.\n    Please use `IconComponent` instead.",
    key: "UIAbstractRatingInput: deprecated `Component` prop",
    url: 'https://tools.hubteamqa.com/ui-library/show/UIComponents/input/abstract/UIAbstractRatingInput'
  }),
  IconComponent: _propTypes.default.elementType,
  disabled: _propTypes.default.bool,
  iconCount: _propTypes.default.number,
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  showPercentage: _propTypes.default.bool.isRequired,
  value: _propTypes.default.number
};
UIAbstractRatingInput.defaultProps = {
  iconCount: 5,
  showPercentage: false
};
UIAbstractRatingInput.displayName = 'UIAbstractRatingInput';

var _default = (0, _Controllable.default)(UIAbstractRatingInput);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/input/abstract/UIAbstractRatingInput.js
// module id = 715
// module chunks = 209 210 211 212